module.exports = __webpack_public_path__ + "static/prottasSiteDemo-4eff6f87b0cd2567bb3b5edd04a3c06a.gif";